var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"placeholder-page"},[_c('i',{staticClass:"el-icon-s-cooperation placeholder-icon"}),_c('div',{staticClass:"placeholder-title"},[_vm._v(_vm._s(_vm.pageTitle))]),_c('div',{staticClass:"placeholder-desc"},[_vm._v("功能开发中，敬请期待")])])
}
var staticRenderFns = []

export { render, staticRenderFns }